import styled from 'styled-components'

export const Container = styled.button`
  position: fixed;
  bottom: 9rem;
  right: 2rem;
  z-index: 999;
  cursor: pointer;
  background: rgba(6, 182, 212, 0.15);
  border: 1px solid rgba(6, 182, 212, 0.3);
  backdrop-filter: blur(8px);
  border-radius: 50%;
  width: 4.8rem;
  height: 4.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: var(--pink);
  transition: opacity 0.3s ease, transform 0.3s ease, background 0.25s, box-shadow 0.25s;
  opacity: 1;

  &:hover {
    transform: translateY(-4px);
    background: rgba(6, 182, 212, 0.3);
    box-shadow: 0 4px 16px rgba(6, 182, 212, 0.3);
  }
  
  &.hidden {
    opacity: 0;
    pointer-events: none;
  }
`
